import React, { useEffect } from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, Link, } from '@one-thd/sui-atomic-components';
import { setContactOverlayAnalytics } from '../../../utils/payments-analytics';
import { CardType } from '../../../constants/payments';
import { getCardImagePath } from '../../../utils/credit-cards';
// may eventually change type to Record<CardType ...>
const headerMappings = {
    [CardType.CREDIT_CARD]: () => {
        return 'Do You Want To Set This Card As Inactive?';
    },
    [CardType.GIFT_CARD]: () => {
        return 'Do You Want To Set This Card As Inactive?';
    },
};
// may eventually change type to Record<CardType ...>
const buttonMappings = {
    [CardType.CREDIT_CARD]: () => {
        return 'Yes, Set Card as Inactive';
    },
    [CardType.GIFT_CARD]: () => {
        return 'Yes, Set Card as Inactive';
    },
};
const childrenMapping = {
    [CardType.CREDIT_CARD]: (card, isB2B, hasHDWallet) => {
        const { cardBrand, cardType, cardNumberLast4, cardExpiryMonth, cardExpiryYear, citiAccountId, } = card;
        if (citiAccountId) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { weight: "bold" }, "Contact Citi directly to set this card inactive. This action can't be undone once it's complete."),
                React.createElement("br", null),
                React.createElement(Typography, null,
                    "Call the Citi customer service number located on the back of your card or visit your",
                    ' ',
                    React.createElement(Link, { href: cardType === 'HR' ? '/MyCRC' : '/Mycard' }, "online Citi account.")),
                React.createElement("br", null),
                React.createElement(Typography, null, "You will continue to have access to purchase history associated with this card, but you will not be able to make new purchases with this card.")));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" },
                "You will not be able to use this card for online purchases",
                hasHDWallet ? ', HD Pass ' : ' ',
                "or remote purchase authorization via phone or Text2Confirm."),
            React.createElement("br", null),
            React.createElement("div", { className: "sui-flex sui-gap-2" },
                React.createElement("img", { width: 33, height: "auto", src: getCardImagePath(cardBrand, cardType), alt: "Credit card logo" }),
                React.createElement(Typography, null,
                    " ****",
                    cardNumberLast4),
                React.createElement(Typography, null, cardExpiryMonth &&
                    cardExpiryYear &&
                    `Exp ${cardExpiryMonth}/${cardExpiryYear.slice(-2)}`)),
            React.createElement("br", null),
            React.createElement(Typography, null, "You can still make purchases in store with the physical card and view purchase history in your account.")));
    },
    [CardType.GIFT_CARD]: () => {
        return (React.createElement(Typography, { variant: "body-base" }, "You'll still be able to review all purchase history associated with this gift card in your account."));
    },
};
export const SetInactiveModal = ({ card, hideModal, onConfirmSetInactive, isLoading, cardType, isB2B, hasHDWallet, }) => {
    const headerText = headerMappings[cardType](card);
    const buttonText = buttonMappings[cardType](card);
    const children = childrenMapping[cardType](card, isB2B, hasHDWallet);
    useEffect(() => {
        if (card.citiAccountId) {
            setContactOverlayAnalytics();
        }
    }, [card.citiAccountId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, headerText),
        React.createElement(ModalBody, null, children),
        React.createElement(ModalFooter, null, card.citiAccountId ? (React.createElement("div", { className: "sui-flex sui-whitespace-nowrap sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
            React.createElement(Button, { variant: "primary", fullWidth: true, onClick: hideModal }, "Got It"))) : (React.createElement("div", { className: "sui-flex sui-whitespace-nowrap sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
            React.createElement(Button, { variant: "secondary", fullWidth: true, onClick: hideModal }, "No"),
            React.createElement(LoadingButton, { variant: "primary", loading: isLoading, fullWidth: true, onClick: onConfirmSetInactive, "data-testid": `${cardType}-set-inactive-confirm-btn` }, buttonText))))));
};
SetInactiveModal.displayName = 'SetInactiveModal';
